import { ref, computed, inject } from 'vue';
import { defineStore } from 'pinia';
import { useStoreOrder } from './order';
import { useApi } from '@/plugins/api';
import { setWithTTL, getWithTTL } from '@/composables/persist';

const LOGGER_TAG = 'checkout-store';

export class SectionConfig {
	config = {};
	constructor(config) {
		this.config = config;
	}

	get() {
		return this.config;
	}

	isVisible() {
		if (this.config.hasOwnProperty('visible') && !this.config.visible) {
			return false;
		}
		return true;
	}
}

export const useStoreCheckout = defineStore('checkout', () => {
	let api = useApi();
	let oStore = useStoreOrder();
	let logger = inject('logger');

	// definitions
	const paymentMethods = ref([]);
	const checkoutForm = ref({});
	const crossSellingProducts = ref([]);
	const config = ref({});
	let paymentRunning = ref(false);

	function setPaymentMethods(methods) {
		let pos = oStore.pos;
		/*if (pos.xpay_payment && pos.xpay_merchant) {
			 methods['googlepay'] = {
				key: 'googlepay',
				label: "Google Pay",
				method: 'googlepay',
				online: true,
				type: 'googlepay',
				visible: [],
				off_methods: []
			};
		}*/

		paymentMethods.value = methods;
	}

	const getCheckoutConfig = async (force = false) => {
		try {
			// Check cache first
			if (!force) {
				const cachedData = getWithTTL('checkout_config');
				if (cachedData) {
					// Reconstruct SectionConfig instances for cached data
					for (let key in cachedData.dm) {
						cachedData.dm[key] = new SectionConfig(cachedData.dm[key].config);
					}
					setPaymentMethods(cachedData.payment_methods);
					config.value = cachedData;
					return cachedData;
				}
			}

			// If not in cache, fetch from API
			let { data } = await api.get('checkout');
			setPaymentMethods(data.payment_methods);

			for (let key in data.dm) {
				data.dm[key] = new SectionConfig(data.dm[key]);
			}

			config.value = data;

			// Cache the response with 10 minutes TTL
			setWithTTL('checkout_config', data, 0.3);

			return data;
		} catch (e) {
			logger.error(LOGGER_TAG, e);
		}
	}

	const setPaymentMethod = async ({ payment_method, payment_method_sub }) => {
		try {
			await api.post('checkout/act/set_payment_method', {
				payment_method,
				payment_method_sub
			});
			await oStore.getOrder();
			return true;
		} catch (e) {
			return false;
		}
	}

	async function doAct(action, id, params = null) {
		try {
			let { data } = await api.post(`checkout/act/${action}${id ? '/' + id : ''}`, params);
			return data;
		} catch (error) {
			logger.error(LOGGER_TAG, error);
		}
	}

	async function submit() {
		return await api.post('checkout/send', checkoutForm.value);
	}

	async function customerDataChange(form) {
		return await api.post('checkout/act/set_customer_data', form);
	}

	async function getCrossSellingProducts() {
		try {
			let { data } = await api.get('/checkout/cross_selling_products');
			crossSellingProducts.value = data;
			return data;
		} catch (error) {
			console.error(LOGGER_TAG, error);
		}
	}

	return {
		paymentMethods, checkoutForm, paymentRunning, crossSellingProducts,
		config,
		getCheckoutConfig, setPaymentMethod, doAct, submit,
		customerDataChange, getCrossSellingProducts
	};
});
